
<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

<div *ngIf="!showSpinner" class="content">

  <mat-toolbar> Equipe {{equipe.nomeEquipe}} </mat-toolbar>
  <mat-card clas="escolha-card">
    <mat-card-title class="escolha-titulo">
      <h2>Escolha do desafio</h2>
      <br/>
      <span class="descricao"> Vote no desafio que mais gostar </span>
    </mat-card-title>
    <mat-card-content>
      <div *ngFor="let desafio of desafios, let i = index">
        <div class="desafio-header" hideToggle>
          <span class="desafio-titulo" (click)="setStep(i)">
            {{desafio.titulo}}
          </span>
          <div class="desafio-titulo-icon">
            <mat-icon *ngIf="step !== i" (click)="setStep(i)">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="step === i" (click)="setStep(i)">keyboard_arrow_up</mat-icon>
          </div>
          <span class="spacer"></span>
          <div class="voto-icon">
            <a *ngIf="votos[i]" (click)="insereVoto(i)">
              <mat-icon color="primary">radio_button_checked</mat-icon>
            </a>
            <a *ngIf="!votos[i]" (click)="insereVoto(i)">
              <mat-icon color="primary">radio_button_unchecked</mat-icon>
            </a>
          </div>
          <div class="voto-count">
            {{votosCount[i]}}
          </div>
        </div>
        <div class="desafio-descricao" [hidden]="step !== i">
          {{desafio.descricao}}
        </div>
        <mat-divider></mat-divider>
      </div>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-flat-button *ngIf="!empatou"
      (click) = "atribuiDesafio()">
        Confirmar
      </button>
    </mat-card-actions>

  </mat-card>
</div>
